import { useEffect, useState } from 'react'
import { Stack } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useAlert } from '~/@ui/alert/useAlert'
import { TopNavigationInvestor } from '../navigation-top/TopNavigationInvestor'
import { getApi } from '~/@utils/api/getApi'
import { AddFunds } from './AddFunds'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import { useCurrentUserData } from '~/@biz_account/useCurrentUserData/useCurrentUserData'

export const AddFundsPage = () => {
  const { showAlert } = useAlert()
  const { user } = useCurrentUserData()

  const [variableSymbol, setVariableSymbol] = useState<null | string>(null)

  const { watch, control } = useForm({
    defaultValues: {
      amount: 50,
    },
  })

  const amount = Number(watch('amount'))

  const getVariableSymbol = async () => {
    try {
      const { data: response } =
        await getApi().investorProfileAppApiControllerGetInvestorVariableSymbol()

      if ('success' in response) {
        setVariableSymbol(response.variableSymbol)
        return
      }

      throw new Error('Nastala chyba pri načítavaní investičných príležitostí.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  useEffect(() => {
    getVariableSymbol()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Stack className="bg-zBlack200">
      <TopNavigationInvestor user={user} />
      <AddFunds
        className="w-full max-w-[768px] self-center pb-28"
        variableSymbol={variableSymbol}
        control={control}
        amount={amount}
      />
    </Stack>
  )
}
